<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="My Devices" pageTitle="Videos" />
            <VideosDevices />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import VideosDevices from '../Videos/VideosDevices'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'VideosPage',
    components: {
        MainHeader,
        PageTitle,
        VideosDevices,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>